<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="71" height="60" viewBox="0 0 71 60" fill="none">
        <path d="M11.5833 45.8454V25.5728H12.8336V44.595H32.308V45.8454H11.5833Z" stroke-width="0.00786369" />
        <path d="M32.3355 22.5373H11.7247L32.3355 9.52686V22.5373Z" stroke-width="0.00786369" />
        <path d="M18.7667 15.6566V18.0904L15.9319 19.8873V15.6566H18.7667Z" stroke-width="0.00786369" />
        <path d="M15.7982 41.5203V25.5728H32.3356V41.5203H15.7982Z" stroke-width="0.00786369" />
        <path d="M31.8479 28.8755H29.0092V31.7221H31.8479V28.8755Z" fill="none" stroke="#738087"
            stroke-width="0.00786369" />
        <path d="M31.8479 32.1782H29.0092V35.0328H31.8479V32.1782Z" fill="none" stroke-opacity="0.137255"
            stroke-width="0.00786369" />
        <path d="M41.9961 7.91876V45.8454" stroke-width="0.495413" />
        <path d="M49.6082 12.1337V45.8453" stroke-width="0.495413" />
        <path d="M33.46 45.5976H58.8597" stroke-width="0.495413" />
        <path d="M33.46 41.2726H55.785" stroke-width="0.495413" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M34.0498 10.5525L61.9266 24.9043L62.1534 24.4639L34.0498 9.9953V10.5525Z" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M34.0498 13.7452L61.9266 28.097L62.1534 27.6565L34.0498 13.188V13.7452Z" />
    </svg>
</template>

<script>
export default {
    props: {
        color: String,
    },
    computed: {
        colorFill() {
            return this.color ? this.color : "#000"
        }
    }
}
</script>

<style scoped>
svg {
    fill: v-bind(colorFill);
    stroke: v-bind(colorFill);
}
</style>